
import { Vue, Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { Icon }
})
export default class AlignGridIndicator extends Vue {
  @Prop()
  display!: string;

  @Prop()
  direction!: string;

  @Prop()
  x!: string;

  @Prop()
  y!: string;

  @Prop()
  hover!: boolean;
}
